import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { IoMdImage } from 'react-icons/io';

import { __t } from '@mssgme/shared';
import { LazyImage } from '@mssgme/ui';
import { useUploads, MediaSizes } from '../../../hooks';

import styles from './ServicesGridItem.scss';

export const ServicesGridItem = ({ item, themeStyles, ...rest }) => {
    const { getMediaSizeUrl } = useUploads();
    const photoUrl = getMediaSizeUrl(item.photoUrl, MediaSizes.Half);

    return (
        <div className={cn(styles.item, styles[themeStyles.gridMode])} {...rest}>
            <div className={styles.thumbnail} style={{ backgroundColor: themeStyles.backgroundColor }}>
                {photoUrl ? (
                    <LazyImage src={photoUrl} alt={item.title} />
                ) : (
                    <div className={styles.emptyPlaceholder}>
                        <IoMdImage size="40%" color="#fff" />
                    </div>
                )}
            </div>
            <div className={styles.meta} style={{ color: themeStyles.color }}>
                <div>
                    <h6 className={styles.title}>{item.title}</h6>
                    {item.price && (
                        <div className={styles.price}>
                            {item.price.formattedDiscount &&
                                (item.price.discount === 0 ? (
                                    <span className={styles.discountPrice}>{__t('free')}</span>
                                ) : (
                                    <span className={styles.discountPrice}>{item.price.formattedDiscount}</span>
                                ))}
                            {item.price.amount === 0 ? (
                                __t('free')
                            ) : (
                                <span className={item.price.formattedDiscount ? styles.lineThrough : null}>
                                    {item.price.formatted}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

ServicesGridItem.propTypes = {
    item: PropTypes.object.isRequired,
    themeStyles: PropTypes.object.isRequired,
};
